import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Col, Row } from "shards-react";

const PageTitle = ({ title, subtitle, showPageGuide, onPageGuideToggle, className, ...attrs }) => {
  const classes = classNames(
    className,
    "text-center",
    "text-md-left",
    "mb-sm-0"
  );

  return (
    <>
    { showPageGuide ? <>
      <Row>
        <Col lg="10" xs="12" sm="4" className={classes} { ...attrs }>
          <span style={{color:"#333"}} className="text-uppercase page-subtitle">{subtitle}</span>
          { subtitle !== "" ? 
            <> <h3 className="page-title">{title}</h3> </> 
            : <> <h3 className="page-title pt-3 mt-1">{title}</h3> </> 
          }
        </Col>
        <Col lg="2">
          <>
            <div className="pt-3" style={{cursor: 'pointer'}} onClick={() => { onPageGuideToggle() }}>
              <img src="./icons/page-guide-icon.png" role="button" style={{width: '20px'}} alt="Page info"/> Page Guide
            </div>
          </>
        </Col>
      </Row>
    </> : 
    <>
      <Col xs="12" sm="4" className={classes} { ...attrs }>
        <span style={{color:"#333"}} className="text-uppercase page-subtitle">{subtitle}</span>
        { subtitle !== "" ? 
          <> <h3 className="page-title">{title}</h3> </> 
          : <> <h3 className="page-title pt-3 mt-1">{title}</h3> </> 
        }
      </Col>
    </> }
      
    </>
  )
};

PageTitle.propTypes = {
  /**
   * The page title.
   */
  title: PropTypes.string,
  /**
   * The page subtitle.
   */
  subtitle: PropTypes.string
};

export default PageTitle;
